(function processTypeDefinition() {
    'use strict';
    angular.module('Entities')
        .service('processTypeService', [
            'restUrlBuilder', function processTypeService(restUrlBuilder) {
                restUrlBuilder = restUrlBuilder('wf');

                this.getProcessTypeById = function getById(id) {
                    var params = { Id: id };
                    return restUrlBuilder.one('ProcessTypes').get({ params: params });
                }

                this.createProcessType = function createProcessType(params) {
                    return restUrlBuilder.all('ProcessTypes').post(params);
                };

                this.getProcessTypeByOuId = function getProcessTypeByOuId(ouid, processTypeName) {
                    var params = {
                        OrganizationalUnitId: ouid,
                        name: processTypeName
                    };

                    return restUrlBuilder.all('ProcessTypes').get({ params: params });
                };

                this.addProcessTypeToWorkflow = function addProcessTypeToWorkflow(processTypeId, workflowName) {
                    var params = {
                        name: workflowName,
                        processTypeId: processTypeId
                    };

                    return restUrlBuilder.all('WorkFlows/AddProcessType').put(params);
                };
            }
        ]);
})();
